import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import VM from 'scratch-vm';

import backdropLibraryContent from '../lib/libraries/backdrops.json';
import backdropTags from '../lib/libraries/backdrop-tags';
import {createRuntimeAsset} from '../lib/library-assets';
import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Backdrop',
        description: 'Heading for the backdrop library',
        id: 'gui.costumeLibrary.chooseABackdrop'
    }
});


class BackdropLibrary extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }
    handleItemSelect (item) {
        createRuntimeAsset(item.md5ext)
            .then(asset => {
                const vmBackdrop = {
                    name: item.name,
                    rotationCenterX: item.rotationCenterX,
                    rotationCenterY: item.rotationCenterY,
                    bitmapResolution: item.bitmapResolution,
                    skinId: null,
                    asset: asset,
                    assetId: asset.assetId,
                    dataFormat: asset.dataFormat,
                    md5: `${asset.assetId}.${asset.dataFormat}`
                };
                return this.props.vm.addBackdrop(item.md5ext, vmBackdrop);
            })
            .catch(error => {
                // eslint-disable-next-line no-alert
                window.alert(`背景加载失败：${error.message || error}`);
            });
    }
    render () {
        return (
            <LibraryComponent
                data={backdropLibraryContent}
                id="backdropLibrary"
                tags={backdropTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

BackdropLibrary.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(BackdropLibrary);
